//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import couponDiscount from "./CouponDiscount";
// import withdrawDiscount from "./WithdrawDiscount";
import couponDiscountList from "./CouponDiscountList";
import withdrawDiscountList from "./WithdrawDiscountList";
// import prepayDiscount from "./PrepayDiscount";
import prepayDiscountList from "./PrepayDiscountList";
import RepayDetailList from "./RepayDetailList";
import preMultiRepay from "@/components/PreMultiRepay";
import Float from "@/js/float";
import { getBizType, inLoanApp } from "@/js/utils";
import EarlySettleChargeRule from "@/components/Repay/EarlySettleChargeRule";
import { CLEAR_PLAN_TYPE_LIST } from "@/config";

export default {
    name: "repayInfo",
    components: {
        // couponDiscount,
        // withdrawDiscount,
        // prepayDiscount,
        preMultiRepay,
        couponDiscountList,
        withdrawDiscountList,
        prepayDiscountList,
        RepayDetailList,
        EarlySettleChargeRule
    },
    data() {
        return {
            isDetailShow: false,
            showEarlySettleChargeRuleDialog: false
        };
    },
    props: {
        repayInitData: Object,
        svipType: String,
        redPacketAmount: String,
        isChooseGold: String,
        actualAmount: String,
        couponUsed: String,
        svipTypeName: String,
        repayPage: Number,
        showRepayfmCoupon: Boolean,
        showRepaydlCoupon: Boolean,
    },
    computed: {
        preMultiRepay() {
            return this.repayInitData.preMultiRepay;
        },
        isCurrentPeriodRepay() {
            return [1, 2].includes(this.repayInitData.repaymentType);
        },
        isPreMultiRepay() {
            return this.repayInitData.repaymentType === 3 && !this.isBill;
        },
        isBill() {
            return [8, 9].includes(this.repayInitData.orderType);
        },
        repayPageInfo() {
            const {
                repaymentType,
                orderType,
                upAmount,
                downAmount,
                isdraw,
                interestFreeCoupon,
                holidayAmount,
                vipVo,
            } = this.repayInitData;
            const { payBackAmount, svipOutPrice } = vipVo || {};
            let text = `原还款金额&nbsp;<span>¥${downAmount}</span>`;
            let repayAmount = this.actualAmount;
            let withdrawAmount = 0;

            if (this.isCurrentPeriodRepay && isdraw) {
                if (interestFreeCoupon > 0) {
                    withdrawAmount = Float.add(
                        withdrawAmount,
                        interestFreeCoupon,
                        2
                    );
                }
                if (holidayAmount > 0) {
                    withdrawAmount = Float.add(
                        withdrawAmount,
                        holidayAmount,
                        2
                    );
                }
                if (this.isChooseGold === "y") {
                    withdrawAmount = Float.add(
                        withdrawAmount,
                        payBackAmount,
                        2
                    );
                }
                if (+this.redPacketAmount > 0) {
                    withdrawAmount = Float.add(
                        withdrawAmount,
                        +this.redPacketAmount,
                        2
                    );
                }
                text =
                    withdrawAmount > 0
                        ? `还款成功后可返现&nbsp;<span>¥${withdrawAmount}</span>`
                        : "";
            }

            if (this.isChooseGold === "y") {
                text = `含${this.svipTypeName}<span>¥${svipOutPrice}</span>，${text}`;
                repayAmount = Float.add(repayAmount, svipOutPrice, 2);
            }
            return {
                isShow:
                    this.isChooseGold === "y" ||
                    (this.isCurrentPeriodRepay && isdraw) ||
                    (!isdraw && upAmount !== downAmount),
                text,
                repayAmount,
                withdrawAmount,
            };
        },
        isPrepay() {
            const { repaymentType, orderType } = this.repayInitData;
            return [0, 5].includes(repaymentType) || [8, 9].includes(orderType);
        },
        glodPageInfo() {
            const { vipVo } = this.repayInitData;
            const { svipOutPrice } = vipVo || {};
            let glodText = ""; // 拍金卡文案

            if (this.isChooseGold === "y") {
                glodText = `含${this.svipTypeName}¥${svipOutPrice}`;
            }

            return {
                isShow:
                    [3, 4].includes(this.repayPage) &&
                    this.isChooseGold === "y",
                glodText,
            };
        },
        defaultListShow() {
            const { repayShowInterestFee, repayShowPrincipal } = this.repayInitData;
            return (repayShowInterestFee > 0 || repayShowPrincipal > 0) && getBizType() == "Loan";
        },
        showEarlySettleChargeRule() {
            // 提前结清规则展示判断
            const {
                appRequestType,
                interestFreeAmount,
                preClearplanType,
                clearPlanType
            } = this.repayInitData;

            return appRequestType === 1
                && interestFreeAmount <= 0
                && inLoanApp()
                && (CLEAR_PLAN_TYPE_LIST.includes(clearPlanType) ||
                    [8, 5].includes(preClearplanType));
        }
    },
    methods: {
        stepperChange(amount, period) {
            this.$emit("stepper-change", amount, period);
        },
        showEarlySettleChargeDailog() {
            this.showEarlySettleChargeRuleDialog = true;
        }
    },
};
